import React, { Component } from "react";
import Mailto from './common/mailTo';

export class WelcomePage extends Component {

     constructor(props) {
          super(props);
          this.state = {
              };
     }

 
    render() {
        return (
            <div>
                <div className="content">
                    <div className="main-content centered-content static-page">
                        <div className="container-sm login-container">
                            <div className="content-container">
                                <div className="container-header">
                                    <h1>Warning</h1>
                                </div>
                                <div className="container-content">
                                    <span className="header-subheader">
                                        <p>Access to the One-Time Password (OTP) feature is restricted. Please navigate to the source application's home page. The OTP is an integral part of the client login process and cannot be accessed as a standalone feature.</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}